import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import styled from 'styled-components'

import Login from './pages/login'
import NotFound from './pages/pageNotFound'
import SideBar from './components/sideBar'
import AddContract from './pages/contract/addContract'
import ContractInfo from './pages/contract/contract'
import Overview from './pages/overview'
import Revenue from './pages/revenue'
import Collection from './pages/collection'
import AddExpense from './pages/expense'
import AddBuddyData from './pages/buddyData'
import SalaryDetails from './pages/salaryDetails'
import BuddyDetails from './pages/buddyInfo'
import ExpenseDetails from './pages/expenseDetail'
import ContractTermAddition from './pages/contract/contractTerm'
import PhonePeSummary from './pages/phonePe'
import RazorpaySummary from './pages/razorpay'
import BankSummary from './pages/bank'
import PhonePeList from './pages/phonePe/phonePeList'
import RazorpayList from './pages/razorpay/razorpayList'
import CollectionSummary from './pages/collectionVerification/collectionSummary'
import CollectionVerification from './pages/collectionVerification/collectionList'
import SubscriptionLogs from './pages/collectionVerification/subscriptionLogs'
import GstInvoices from './pages/gst/gstInvoices'
import GstSummary from "./pages/gst/gstSummary";

function App() {
  const isUserLoggedIn = !!localStorage.getItem('access_id');

  return (
    <Router>
      <MainContainer>
        {isUserLoggedIn ? (
          <>
            <SideBar />
            <ContainerBody>
              <Routes>
                <Route path="/" element={<Overview />} />
                <Route path="/revenue" element={<Revenue />} />
                <Route path="/collection" element={<Collection />} />
                <Route path="/addContract" element={<AddContract />} />
                <Route path="/contractInfo" element={<ContractInfo />} />
                <Route path="/addExpense" element={<AddExpense />} />
                <Route path="/addcontractterms" element={<ContractTermAddition />} />
                <Route path="/salaryDetails" element={<SalaryDetails />} />
                <Route path="/buddyData" element={<AddBuddyData />} />
                <Route path="/buddyinfo" element={<BuddyDetails />} />
                <Route path="/expenseDetails" element={<ExpenseDetails />} />
                <Route path="/phonepe" element={<PhonePeSummary />} />
                <Route path="/phonepe-list" element={<PhonePeList />} />
                <Route path="/razorpay" element={<RazorpaySummary />} />
                <Route path="/bank" element={<BankSummary />} />
                <Route path="/razorpay-collection" element={<RazorpayList />} />
                <Route path="/collection-summary" element={<CollectionSummary />} />
                <Route path="/collection-verification" element={<CollectionVerification />} />
                <Route path="/subscriptionLogs" element={<SubscriptionLogs />} />
                <Route path="/gst/invoices" element={<GstInvoices />} /> 
                <Route path="/gst/summary" element={<GstSummary />} />
                {/* NotFound route moved outside the conditional rendering */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ContainerBody>
          </>
        ) : (
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        )}
      </MainContainer>
    </Router>
  );
}

export default App;

export const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const ContainerBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #F0F2F5;
  width: 85vw;
`;
